import React from 'react';
import { colors, styles } from '../styles/styles';

/**
 * Back button component
 */
const BackButton = ({ onClick }) => (
    <button 
        onClick={onClick}
        style={{
            background: 'none',
            border: 'none',
            padding: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center'
        }}
    >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke={colors.textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    </button>
);

/**
 * Reusable page header component
 * This standardizes the page title headers used across multiple components
 */
const PageHeader = ({ 
    leftContent, 
    rightContent, 
    title,
    onBack, 
    className
}) => {
    return (
        <div 
            className={className}
            style={styles.pageHeaderContainer}
        >
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px'
            }}>
                {onBack && <BackButton onClick={onBack} />}
                
                {title && (
                    <span style={{
                        fontSize: title.large ? '22px' : '16px',
                        fontWeight: title.large ? '600' : '500',
                        color: colors.textPrimary,
                    }}>
                        {title.text}
                    </span>
                )}
                
                {leftContent}
            </div>
            
            {rightContent}
        </div>
    );
};

export default PageHeader;
export { BackButton }; 